export const tenantFeatureFlagNames = {
    UseInvoices: 'useInvoices',
    UseLotKpis: 'useLotKpis',
    UseAmazonStorageReport: 'useAmazonStorageReport',
    UseStorageReport: 'useStorageReport',
    UseOneOnOne: 'useOneOnOne',
    UseInspections: 'useInspections',
    UseLotAccess: 'useLotAccess',
    UseMobileApp: 'useMobileApp',
    UseUserTasks: 'useUserTasks',
    UseVendorQuoteButton: 'useVendorQuoteButton',
}

export const tenantFeatureFlagLabels = {
    [tenantFeatureFlagNames.UseInvoices]: "Use Invoicing",
    [tenantFeatureFlagNames.UseLotKpis]: "Use Lot KPIs (dashboard)",
    [tenantFeatureFlagNames.UseAmazonStorageReport]: "Use Amazon Storage Report",
    [tenantFeatureFlagNames.UseStorageReport]: "Use Daily Storage Report (Element/HUB)",
    [tenantFeatureFlagNames.UseOneOnOne]: "Use One On One",
    [tenantFeatureFlagNames.UseInspections]: "Use Inspections",
    [tenantFeatureFlagNames.UseUserTasks]: "Use User Tasks",
    [tenantFeatureFlagNames.UseLotAccess]: "Use Lot Access",
    [tenantFeatureFlagNames.UseMobileApp]: "Use Mobile App",
    [tenantFeatureFlagNames.UseVendorQuoteButton]: "Use Vendor Quote Button (email)"
}

export const tenantDispatchNames = {
    DispatchName: 'dispatchName',
    DispatchEmail: 'dispatchEmail',
    DispatchPhone: 'dispatchPhone',
}

export const tenantDispatchLabels = {
    [tenantDispatchNames.DispatchName]: "Dispatch Name",
    [tenantDispatchNames.DispatchEmail]: "Dispatch Email",
    [tenantDispatchNames.DispatchPhone]: "Dispatch Phone",
}